import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { withOfferChildsReducer, withOfferChildsSaga } from './withReducer';
import messages from './messages';

import { storeChildOffer, deleteChildOffer, resetErrors } from './actions';

import {
  makeSelectDeposit as makeSelectMainDeposit,
  makeSelectDuration as makeSelectMainDuration,
  makeSelectMonthlyRate as makeSelectMainMonthlyRate,
  makeSelectDistance as makeSelectMainDistance,
} from '../OfferValue/selectors';

import ChildItem from './item';

import { makeSelectChildOffers, makeSelectHasError } from './selectors';

import './styles.scss';
import { isArray } from 'lodash';

class OfferChilds extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newDeposit: '',
      newDistance: '',
      newDuration: '',
      newMonthlyRate: '',
      cloningId: false,
    };
  }

  handleOnCloneToggle(id) {
    this.setState({
      cloningId: this.state.cloningId > 0 ? false : id,
    });

    this.props.resetErrors();
  }

  render() {
    const {
      childs,
      mainMonthlyRate,
      mainDeposit,
      mainDuration,
      mainDistance,
      hasError
    } = this.props;
    const { cloningId } = this.state;

    if (isArray(childs)) {
      if (cloningId) {
        if (!childs.some(child => child.cloning && child.cloning > 0)) { // evito clonazione doppie
          const clonedIdx = childs.findIndex(child => child.ref === cloningId);
          const cloning = childs[clonedIdx];

          if (cloning) {
            childs.splice(clonedIdx + 1, 0, {
              deposit: cloning.deposit,
              duration: cloning.duration,
              distance: cloning.distance,
              monthly_rate: cloning.monthly_rate,
              cloning: cloningId
            });
          }
        }
      } else {
        const cloningIdx = childs.findIndex(child => child.cloning && child.cloning > 0);

        if (cloningIdx >= 0) {
          childs.splice(cloningIdx, 1);
        }
      }
    }

    return (
      <div id="OfferChilds">
        <table className="table">
          <thead>
            <tr>
              <th>{messages.deposit.title}</th>
              <th>{messages.distance.title}</th>
              <th>{messages.duration.title}</th>
              <th>{messages.price.title}</th>
              <th>{messages.actions.title}</th>
            </tr>
          </thead>
          <tbody className="text-center">

            {childs &&
              childs.length > 0 &&
              childs.map(child =>
                <ChildItem
                  key={child.ref || `cloninh-${child.cloning}`}
                  id={child.ref || false}
                  deposit={child.deposit}
                  duration={child.duration}
                  distance={child.distance}
                  monthly_rate={child.monthly_rate}
                  mainMonthlyRate={mainMonthlyRate}
                  mainDeposit={mainDeposit}
                  mainDuration={mainDuration}
                  mainDistance={mainDistance}
                  hasError={hasError}
                  canClone={cloningId === false}
                  onClone={() => this.handleOnCloneToggle(child.ref)}
                  isCloningRow={child.ref === undefined}
                />
              )
            }

            <ChildItem
              mainMonthlyRate={mainMonthlyRate}
              mainDeposit={mainDeposit}
              mainDuration={mainDuration}
              mainDistance={mainDistance}
              hasError={hasError}
            />

          </tbody>
        </table>
      </div>
    );
  }
}

OfferChilds.propTypes = {
  // hasError: PropTypes.func.isRequired,

  mainMonthlyRate: PropTypes.number,
  mainDeposit: PropTypes.number,
  mainDuration: PropTypes.number.isRequired,
  mainDistance: PropTypes.number.isRequired,
  // mainHasError: PropTypes.bool.isRequired,

  childs: PropTypes.any,
  duration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  deposit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  distance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const mapStateToProps = createStructuredSelector({
  mainMonthlyRate: makeSelectMainMonthlyRate(),
  mainDeposit: makeSelectMainDeposit(),
  mainDuration: makeSelectMainDuration(),
  mainDistance: makeSelectMainDistance(),
  childs: makeSelectChildOffers(),
  hasError: makeSelectHasError(),
});

export function mapDispatchToProps(dispatch) {
  return {
    storeChildOffer: value => dispatch(storeChildOffer(value)),
    deleteChildOffer: id => dispatch(deleteChildOffer(id)),
    resetErrors: () => dispatch(resetErrors()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withOfferChildsSaga,
  withOfferChildsReducer,
  withConnect,
)(OfferChilds);
